import API from "../../utils/axios";
import { setChangedVehicles, setProject, setShowingRouteId } from "./project";
import { enqueueSnackbar } from "./snackbars";
import {
  setLoadingRoutesList,
  setLoadingUnscheduled,
  setLoadingStop
} from "./loading";
import { client } from "../../components/map/DriverMarkers";
import { setSolution } from "./solution";

import { cleanSolutionWithNewRoutes } from "./custom";

export const findRouteIndexById = (id, solution) => {
  return solution.routes.findIndex(route => route.id === id);
};

// const findRouteById = (id, solution) => {
//   return solution.routes.find(route => route.id === id);
// };

export const dragFromRouteToRoute =
  ({
    sourceId,
    destinationId,
    destIndex,
    selection,
    successMessage,
    isBreakInDraggingList
  }) =>
  (dispatch, getState) => {
    // Count the changes

    const { solution, showingRouteId } = getState().project;
    const route1Index = findRouteIndexById(sourceId, solution);
    const route2Index = findRouteIndexById(destinationId, solution);

    const route1 = solution.routes[route1Index];
    const route2 = solution.routes[route2Index];

    dispatch(setChangedVehicles(route1.vehicle_id));
    dispatch(setChangedVehicles(route2.vehicle_id));

    // PUT updates to API
    API.put(
      `v1/projects/${getState().project.id}/move_service/routes/${
        route2.id
      }?index=${destIndex}`,
      selection
    )
      .then(res => {
        if (successMessage) {
          dispatch(enqueueSnackbar({ message: successMessage }));
        }
        const newSolution = cleanSolutionWithNewRoutes(
          { ...solution },
          res.data.routes
        );
        res.data.routes.forEach(route => {
          const routeIndex = findRouteIndexById(route.id, newSolution);
          newSolution.routes[routeIndex] = route;
          sendReorderWSMessage(route.id);
        });
        if (
          showingRouteId !== "" &&
          findRouteIndexById(showingRouteId, newSolution) < 0
        ) {
          dispatch(setShowingRouteId(res.data.routes[0].id));
        }
        dispatch(setSolution(newSolution));
      })
      .catch(error => {
        dispatch(enqueueSnackbar({ message: "Something went wrong" }));

        console.log(error);
      })
      .finally(() => {
        if (isBreakInDraggingList) {
          dispatch(
            enqueueSnackbar({
              message: "Can't drag and drop break outside from route"
            })
          );
        }
        dispatch(setLoadingStop(false));
        dispatch(setLoadingRoutesList(false));
      });
  };

function replaceMultipleElements(originalIds, draggedIds, destinationIndex) {
  // Get the IDs of the dragged elements
  const draggedElementIds = draggedIds;

  // Create an empty array to store the updated original IDs
  const updatedOriginalIds = [];

  // Iterate through the original IDs
  for (let i = 0; i < originalIds.length; i++) {
    // Check if the current ID is not included in the dragged IDs
    if (!draggedElementIds.includes(originalIds[i])) {
      // Add the current ID to the updated original IDs
      updatedOriginalIds.push(originalIds[i]);
    }
  }

  // Insert the dragged IDs at the specified destination index
  updatedOriginalIds.splice(destinationIndex, 0, ...draggedElementIds);

  // Return the updated original IDs array
  return updatedOriginalIds;
}

export const dragInsideRoute =
  ({ sourceId, sourceIndex, destIndex, selection, successMessage }) =>
  (dispatch, getState) => {
    // Reorder ignoring "start" and "end"
    const { solution } = getState().project;
    const routeIndex = findRouteIndexById(sourceId, solution);
    const route = solution.routes[routeIndex];

    const allActivities = route.stops.map(stop => stop.id);
    let [start, services, end] = [
      allActivities[0],
      allActivities.slice(1, allActivities.length - 1),
      allActivities[allActivities.length - 1]
    ];

    // Count the change
    dispatch(setChangedVehicles(route.vehicle_id));

    let newServices = [];
    const sortedSelection = selection.sort((a, b) => {
      const aIndex = services.findIndex(id => id === a);
      const bIndex = services.findIndex(id => id === b);
      return aIndex - bIndex;
    });

    if (typeof sourceIndex === "number" && sourceIndex < destIndex) {
      const realDestId = services[destIndex];
      services = services.filter(id => !sortedSelection.includes(id));
      const serviceDestIndex = services.findIndex(id => id === realDestId);
      const selectedServiceDestIndex = services.findIndex(
        id => id === sortedSelection[0]
      );

      let realDestIndex = destIndex;
      if (sortedSelection.length > 1) {
        realDestIndex =
          serviceDestIndex > selectedServiceDestIndex
            ? serviceDestIndex + 1
            : serviceDestIndex;
      }

      newServices = replaceMultipleElements(
        services,
        sortedSelection,
        realDestIndex
      );
    } else {
      newServices = replaceMultipleElements(
        services,
        sortedSelection,
        destIndex
      );
    }

    const newActivities = [start, ...newServices, end];

    // Update activities sequence
    API.patch(
      `/v1/projects/${getState().project.id}/routes/${sourceId}`,
      newActivities
    )
      .then(res => {
        // window.mixpanel && window.mixpanel.track("DnD inside route");

        sendReorderWSMessage(route.id);
        if (successMessage)
          dispatch(enqueueSnackbar({ message: successMessage }));
        const newSolution = { ...solution };
        newSolution.routes[routeIndex] = res.data;
        dispatch(setSolution(newSolution));
      })
      .catch(error => {
        dispatch(enqueueSnackbar({ message: "Something went wrong" }));
        console.log(error);
      })
      .finally(() => {
        dispatch(setLoadingStop(false));
        dispatch(setLoadingRoutesList(false));
      });
  };

export const dragFromUnassignedToRoute =
  ({ destinationId, destIndex, selection, successMessage, callback }) =>
  (dispatch, getState) => {
    dispatch(setLoadingUnscheduled(true));
    const { solution, showingRouteId } = getState().project;
    const routeIndex = findRouteIndexById(destinationId, solution);
    const route = solution.routes[routeIndex];

    dispatch(setChangedVehicles(route.vehicle_id));

    // PUT updates to API
    API.put(
      `v1/projects/${getState().project.id}/move_service/routes/${
        route.id
      }?index=${destIndex}`,
      selection
    )
      .then(res => {
        // window.mixpanel && window.mixpanel.track("DnD unassigned->route");

        if (successMessage)
          dispatch(enqueueSnackbar({ message: successMessage }));

        const newSolution = cleanSolutionWithNewRoutes(
          { ...solution },
          res.data.routes
        );
        res.data.routes.forEach(route => {
          const routeIndex = findRouteIndexById(route.id, newSolution);
          newSolution.routes[routeIndex] = route;
          sendReorderWSMessage(route.id);
        });
        if (
          showingRouteId !== "" &&
          findRouteIndexById(showingRouteId, newSolution) < 0
        ) {
          dispatch(setShowingRouteId(res.data.routes[0].id));
        }
        newSolution.unassigned.stops = newSolution.unassigned.stops.filter(
          stop => !selection.includes(stop.id)
        );
        dispatch(setSolution(newSolution));

        dispatch(setProject(res.data));
        callback && callback(undefined, res.data);
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message:
              "Can't add the stop to this route, impossible to calculate the distance and the duration to it"
          })
        );
        console.log(error);
        callback && callback(error);
      })
      .finally(() => {
        dispatch(setLoadingStop(false));
        dispatch(setLoadingRoutesList(false));
        dispatch(setLoadingUnscheduled(false));
      });
  };

export const unassignStops =
  ({ sourceId, selection, successMessage, isBreakInDraggingList }) =>
  (dispatch, getState) => {
    dispatch(setLoadingUnscheduled(true));
    const { solution, showingRouteId } = getState().project;
    const routeIndex = findRouteIndexById(sourceId, solution);
    const route = solution.routes[routeIndex];

    dispatch(setChangedVehicles(route.vehicle_id));

    // PUT updates to API
    API.put(
      `v1/projects/${getState().project.id}/move_service_to_unassigned/routes/${
        route.id
      }`,
      selection
    )
      .then(res => {
        if (successMessage)
          dispatch(enqueueSnackbar({ message: successMessage }));
        const newSolution = cleanSolutionWithNewRoutes(
          { ...solution },
          res.data.routes
        );
        res.data.routes.forEach(route => {
          const routeIndex = findRouteIndexById(route.id, newSolution);
          newSolution.routes[routeIndex] = route;
          sendReorderWSMessage(route.id);
        });
        if (
          showingRouteId !== "" &&
          findRouteIndexById(showingRouteId, newSolution) < 0
        ) {
          dispatch(setShowingRouteId(res.data.routes[0].id));
        }
        newSolution.unassigned.stops = [
          ...res.data.unassigned,
          ...newSolution.unassigned.stops
        ];
        dispatch(setSolution(newSolution));
      })
      .catch(error => {
        dispatch(enqueueSnackbar({ message: "Something went wrong" }));

        console.log(error);
      })
      .finally(() => {
        if (isBreakInDraggingList) {
          dispatch(
            enqueueSnackbar({
              message: "Can't drag and drop break outside from route"
            })
          );
        }
        dispatch(setLoadingStop(false));
        dispatch(setLoadingRoutesList(false));
        dispatch(setLoadingUnscheduled(false));
      });
  };

export const sendReorderWSMessage = routeId => {
  client &&
    client.send(
      JSON.stringify({
        type: "route_reorder",
        route_id: routeId
      })
    );
};
